import { render, staticRenderFns } from "./TableManagement.vue?vue&type=template&id=3a420f0a&scoped=true"
import script from "./TableManagement.vue?vue&type=script&lang=js"
export * from "./TableManagement.vue?vue&type=script&lang=js"
import style0 from "./TableManagement.vue?vue&type=style&index=0&id=3a420f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a420f0a",
  null
  
)

export default component.exports